module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_111-9ab12c274304ac49f514ed2fbff9ae8b.png";